/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkRunDetailDto } from '../../models/benchmark-run-detail-dto';

export interface ApiAdminBenchmarkRunsRunIdGet$Params {
  runId: string;
}

export function apiAdminBenchmarkRunsRunIdGet(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarkRunsRunIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunDetailDto>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarkRunsRunIdGet.PATH, 'get');
  if (params) {
    rb.path('runId', params.runId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BenchmarkRunDetailDto>;
    })
  );
}

apiAdminBenchmarkRunsRunIdGet.PATH = '/api/Admin/benchmark-runs/{runId}';
